import { StyleSheet } from 'react-native';

import { theme } from 'styles/configure-theme';
import { isWeb } from 'utils/environment';

export const contentStyles = StyleSheet.create({
  content: {
    backgroundColor: theme.token('background-pattern'),
    padding: 0,
    ...(isWeb ? { overflowY: 'scroll' as const } : {}),
  },
});
